<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：联系我们
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index')!=-1?'active':''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice')!=-1?'active':''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news')!=-1?'active':''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message')!=-1?'active':''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department')!=-1?'active':''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information')!=-1?'active':''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact')!=-1?'active':''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <!--<div id="banner">
      <Carousel
        v-model="banner"
        :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed"
        :dots="setting.dots"
        :radius-dot="setting.radiusDot"
        :trigger="setting.trigger"
        :arrow="setting.arrow">
        <CarouselItem v-for="(item,index) in bannerlist" :key="index">
          <div class="demo-carousel">
            <img :src="'/dev-api'+item.filePath" width="100%" alt="item.title">
          </div>
        </CarouselItem>
      </Carousel>
    </div>-->
    <div class="contact_title">联系我们</div>
    <div id="contact">
    
      <div class="contact_main">
        <div class="contact_main_info">
          <!--start-->
          <div class="contact_main_info_item">
            <div class="contact_main_info_item_img">
              <img src="../../static/imgs/contact_address.png" width="40" height="40" alt="">
            </div>
            <div class="contact_main_info_item_content">
              <div class="contact_main_info_item_content_title">青岛市黄岛区第五人民医院</div>
              <div class="contact_main_info_item_content_text">{{base.contact_address}}</div>
            </div>
          </div>
          <!--end-->
          <!--start-->
          <div class="contact_main_info_item">
            <div class="contact_main_info_item_img">
              <img src="../../static/imgs/contact_tel.png" width="40" height="40" alt="">
            </div>
            <div class="contact_main_info_item_content">
              <div class="contact_main_info_item_content_title">联系电话</div>
              <div class="contact_main_info_item_content_text">{{base.contact_phone}}</div>
            </div>
          </div>
          <!--end-->
          <!--start-->
          <div class="contact_main_info_item">
            <div class="contact_main_info_item_img">
              <img src="../../static/imgs/contact_email.png" width="40" height="40" alt="">
            </div>
            <div class="contact_main_info_item_content">
              <div class="contact_main_info_item_content_title">邮箱</div>
              <div class="contact_main_info_item_content_text">{{base.contact_email}}</div>
            </div>
          </div>
          <!--end-->
          <!--start-->
          <div class="contact_main_info_item">
            <div class="contact_main_info_item_img">
              <img src="../../static/imgs/contact_web.png" width="40" height="40" alt="">
            </div>
            <div class="contact_main_info_item_content">
              <div class="contact_main_info_item_content_title">网址</div>
              <div class="contact_main_info_item_content_text">{{base.contact_website}}</div>
            </div>
          </div>
          <!--end-->
        </div>
        <div class="contact_main_img">
          <img :src="'/dev-api'+base.contact_pic" width="780" height="590" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  export default {
    data() {
      return {
        /*是否正在加载*/
        routerstr:'/contact',
        loading: true,
        /*背景图片*/
        bgimg_url: '',
        /*是否正在提交*/
        logining: false,
        /*基础配置*/
        banner:0,
        bannerlist:[],
        activeStatus:0,
        setting: {
          autoplay: false,
          autoplaySpeed: 2000,
          dots: 'inside',
          radiusDot: false,
          trigger: 'click',
          arrow: 'hover'
        },
        base:{
          top_phone:'',//联系电话-顶部
          contact_phone:'',//联系电话-联系我们
          bottom_phone:'',//联系电话-底部
          post_code:'',//邮政编码
          contact_address:'',//地址-联系我们
          contact_website:'',//网址-联系我们
          contact_email:'',//邮箱-联系我们
          contact_pic:'',//图片-联系我们
        },

      };
    },
    created() {
      this.getData();
      this.getBanner();

    },
    methods: {
      /*页面跳转*/
      pageClick(row) {
        this.$router.push(row);
      },
      /*获取基础配置*/
      getData() {
        let self = this;
        IndexApi.baseinfo(true)
          .then(res => {
            self.loading = false;
            var list = res.data;
            for (let i=0;i<list.length;i++){
              if(list[i].dictParentKey=='top_phone'){
                self.base.top_phone = list[i].dictName;
              }
              if(list[i].dictParentKey=='contact_phone'){
                self.base.contact_phone = list[i].dictName;
              }
              if(list[i].dictParentKey=='bottom_phone'){
                self.base.bottom_phone = list[i].dictName;
              }
              if(list[i].dictParentKey=='post_code'){
                self.base.post_code = list[i].dictName;
              }
              if(list[i].dictParentKey=='contact_address'){
                self.base.contact_address = list[i].dictName;
              }
              if(list[i].dictParentKey=='contact_website'){
                self.base.contact_website = list[i].dictName;
              }
              if(list[i].dictParentKey=='contact_email'){
                self.base.contact_email = list[i].dictName;
              }
              if(list[i].dictParentKey=='contact_pic'){
                self.base.contact_pic = list[i].dictName;
              }
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      getBanner() {
        let self = this;
        IndexApi.banner(true)
          .then(res => {
            self.loading = false;
            self.bannerlist = res.data;

          })
          .catch(error => {
            self.loading = false;
          });
      },

    }
  };
</script>

<style lang="scss" scoped>
.contact_main_info_item_img{
  margin-right: 10px;
}
.contact_title{
  height:150px;width:100%;background: #007E4F;line-height: 150px;text-align: center;font-size:36px;color:#fff;font-weight: bold;margin-bottom: 30px;
}
#contact{
  width:1180px;margin:0 auto;
 
  .contact_main{
    display: flex;justify-content: space-between;
    .contact_main_info{
      width:662px;height:590px;box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.25);padding:30px;
      .contact_main_info_item{
        padding:40px 20px;display: flex;position: relative;
        .contact_main_info_item_content{
          .contact_main_info_item_content_title{
            font-size:19px;color:#333;font-weight: bold;
          }
          .contact_main_info_item_content_text{
            font-size:14px;color:#333;
          }
        }
      }
      .contact_main_info_item::before{
        position: absolute;content:'';left:0;bottom:0;right:0;height:2px;background: rgba(222,222,222,0.87);
      }
      .contact_main_info_item:last-child::before{background: none;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue